import { FC } from 'react'
import { SwaggerRoutes, RouteTypeEnum } from '../types'
import { AccordionTypeGroup } from './AccordionTypeGroup'

interface PermissionsRouteListProps {
  groupedRoutes: Record<string, Record<string, SwaggerRoutes[]>>
  expandedGroups: Set<string>
  expandedTags: Set<string>
  selectedPermissions: number[]
  onToggleType: (routeType: string) => void
  onSelectAllType: (routeType: string) => void
  onToggleTag: (routeType: string, tag: string) => void
  onSelectAllTag: (routeType: string, tag: string) => void
  onToggleRoute: (routeId: number) => void
  isGroupFullySelected: (routeType: string) => boolean
  isGroupPartiallySelected: (routeType: string) => boolean
  isTagFullySelected: (routeType: string, tag: string) => boolean
  isTagPartiallySelected: (routeType: string, tag: string) => boolean
  getMethodColor: (method: string) => string
  getTypeLabel: (type: string) => string
}

export const PermissionsRouteList: FC<PermissionsRouteListProps> = ({
  groupedRoutes,
  expandedGroups,
  expandedTags,
  selectedPermissions,
  onToggleType,
  onSelectAllType,
  onToggleTag,
  onSelectAllTag,
  onToggleRoute,
  isGroupFullySelected,
  isGroupPartiallySelected,
  isTagFullySelected,
  isTagPartiallySelected,
  getMethodColor,
  getTypeLabel,
}) => {
  if (Object.keys(groupedRoutes).length === 0) {
    return (
      <div className='text-center py-5'>
        <p className='text-muted'>Nenhuma rota encontrada</p>
      </div>
    )
  }

  return (
    <div className='accordion' id='routesAccordion'>
      {Object.entries(groupedRoutes).map(([routeType, tagGroups]) => (
        <AccordionTypeGroup
          key={routeType}
          routeType={routeType}
          tagGroups={tagGroups}
          isExpanded={expandedGroups.has(routeType)}
          isFullySelected={isGroupFullySelected(routeType)}
          isPartiallySelected={isGroupPartiallySelected(routeType)}
          selectedPermissions={selectedPermissions}
          expandedTags={expandedTags}
          onToggleType={onToggleType}
          onSelectAllType={onSelectAllType}
          onToggleTag={onToggleTag}
          onSelectAllTag={onSelectAllTag}
          onToggleRoute={onToggleRoute}
          isTagFullySelected={isTagFullySelected}
          isTagPartiallySelected={isTagPartiallySelected}
          getMethodColor={getMethodColor}
          getTypeLabel={getTypeLabel}
        />
      ))}
    </div>
  )
}
